{
  "SET_NEW_PASSWORD": {
    "TITLE": "Nastavite novo geslo",
    "PASSWORD": {
      "LABEL": "Geslo",
      "PLACEHOLDER": "Geslo",
      "ERROR": "Geslo je prekratko."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Potrdite geslo",
      "PLACEHOLDER": "Potrdite geslo",
      "ERROR": "Gesli se ne ujemata."
    },
    "API": {
      "SUCCESS_MESSAGE": "Uspešno spremenjeno geslo.",
      "ERROR_MESSAGE": "Ni bilo mogoče vzpostaviti povezave s strežnikom. Prosimo poskusite ponovno."
    },
    "CAPTCHA": {
      "ERROR": "Preverjanje je poteklo. Ponovno rešite captcho."
    },
    "SUBMIT": "Pošlji"
  }
}
